import './index.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import './lib/sentry';
import './lib/i18n';
import App from './App.tsx';
import { initializeTheme } from './lib/theme';

initializeTheme();

const root = createRoot(document.getElementById('root') as HTMLElement, {
  onUncaughtError(error) {
    console.error('Uncaught error:', error);
    Sentry.captureException(error);
  },
  onCaughtError(error) {
    console.error('Caught error:', error);
    Sentry.captureException(error);
  },
  onRecoverableError(error) {
    console.warn('Recoverable error:', error);
    Sentry.captureException(error);
  },
});

root.render(<App />);
